import { useTranslation } from "src/context/Translations/context";
import React from "react";
import { RCCGrid, RCCInput, RCCSelectOptionsCard, RCCTextArea } from "react-common-components";
import LovSectors from "src/components/Lov/Sectors";
import LovUsers from "src/components/Lov/Users";
import { useAuth } from "src/context/Auth/context";

import DateTimePickerRange from "src/components/DateTimePickerRange";
import LovProcess from "src/components/Lov/Process";
import LovStandards from "src/components/Lov/Standards";
import { AuditType } from "../../interface";
import { IFormSimplifiedFields } from "./interface";

const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	audit,
	isDisabled,
	isCopy,
	control,
	error,
	register,
	onChangeStandard
}) => {

	const { translate } = useTranslation();
	const { user } = useAuth();


	const defaultValue = (value: any, label: any) => {
		if(label && value)
			return { value: String(value), label};

		if(value)
			return value.toString();

		return "";
	};


	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>				
				<RCCGrid
					container
					item
					sm={8}
					xs={12}
				>
					<RCCGrid
						container
						item
					>
						<RCCSelectOptionsCard
							name="adb001Tipo"
							control={control}
							defaultValue={audit.adb001Tipo ? String(audit.adb001Tipo) : String(AuditType.INTERNAL)}
							options={[
								{
									value: String(AuditType.INTERNAL),
									label:translate("Interna")
								},
								{
									value: String(AuditType.EXTERNAL),
									label:translate("Externa")
								}
							]}
							label={translate("Tipo")}
						/>
					</RCCGrid>    
					<RCCGrid
						container
						item
						sm={3}
						xs={12}
					>
						<RCCInput 
							name="adb001Codigo"
							label={translate("Código")}
							maxLength={40}
							register={register}
							defaultValue={audit.adb001Codigo}
							error={error.adb001Codigo}
							disabled={isDisabled}
						/>
					</RCCGrid>
					<RCCGrid
						container
						item		
					>
						<RCCInput 
							name="adb001Titulo"
							label={translate("Título")}
							maxLength={200}
							register={register}
							defaultValue={isCopy ? `(${translate("CÓPIA")}) ${audit.adb001Titulo}` : audit.adb001Titulo}
							error={error.adb001Titulo}
							disabled={isDisabled}
							required
						/>
					</RCCGrid>
					<RCCGrid
						container
						item		
					>
						<RCCTextArea 
							name="adb001Descricao"
							label={translate("Descrição")}
							maxLength={4000}	
							register={register}
							defaultValue={audit.adb001Descricao}
							error={error.adb001Descricao}
							disabled={isDisabled}
							required
						/>
					</RCCGrid>
					<RCCGrid
						container
						item
					>
						<DateTimePickerRange
							control={control}
							type="datePicker"
							label={translate("Data Planejada")}
							labelSeparator={translate("Até")}
							nameInit="adb001Dtinicioplan"
							nameEnd="adb001Dtfimplan"
							defaultValueInit={audit.adb001Dtinicioplan ? audit.adb001Dtinicioplan : new Date()}
							defaultValueEnd={audit.adb001Dtfimplan ? audit.adb001Dtfimplan : new Date()}
							error={error.adb001Dtinicioplan || error.adb001Dtfimplan}
							required
							props={{
								datePicker: {
									disabled: isDisabled
								}
							}}
						/>
					</RCCGrid>
					{
						!isCopy && (audit.adb001Dtinireal || audit.adb001Dtfimreal) &&
						<RCCGrid
							container
							item
						>
							<DateTimePickerRange
								control={control}
								type="datePicker"
								label={translate("Data Realizada")}
								labelSeparator={translate("Até")}
								nameInit="adb001Dtinireal"
								nameEnd="adb001Dtfimreal"
								defaultValueInit={audit.adb001Dtinireal ? audit.adb001Dtinireal : undefined}
								defaultValueEnd={audit.adb001Dtfimreal ? audit.adb001Dtfimreal : undefined}
								error={error.adb001Dtinireal || error.adb001Dtfimreal}
								required
								props={{
									datePicker: {
										disabled: true
									}
								}}
							/>
						</RCCGrid>
					}
					<RCCGrid
						container
						item		
					>
						<LovSectors 
							control={control}
							name="adb001Taa001Id"
							label={translate("Setor")}
							defaultValue={defaultValue(audit.adb001Taa001Id, audit.adb001Taa001Descricao)}
							required
							disabled={isDisabled}
							error={error.adb001Taa001Id}
							isCreatable
						/>
					</RCCGrid>
					<RCCGrid 
						container 
						item
					>
						<LovStandards
							name="adb001Ada001Id"
							label={translate("Norma")}
							control={control}
							defaultValue={defaultValue(audit.adb001Ada001Id, audit.adb001Ada001Descricao)}
							onChangeCapture={onChangeStandard}
							disabled={isDisabled}
							isClearable
						/>		
					</RCCGrid>
					<RCCGrid 
						container 
						item
					>
						<LovProcess
							name="adb001Taa005Id"
							label={translate("Processo")}
							control={control}
							error={error.adb001Taa005Id}
							isCreatable
							defaultValue={defaultValue(audit.adb001Taa005Id, audit.adb001Taa005Descricao)}
							disabled={isDisabled}
							required
						/>		
					</RCCGrid>	
					<RCCGrid
						container
						item		
					>
						<LovUsers 
							control={control}
							name="adb001Efa005Id"
							label={translate("Gestor")}
							error={error.adb001Efa005Id}
							defaultValue={audit.adb001Efa005Id ? defaultValue(audit.adb001Efa005Id, audit.adb001Efa005Nome) : {
								value: user.efa005Id.toString(),
								label: user.efa005Nome
							}}
							disabled={isDisabled}
							required
						/> 
					</RCCGrid>
					<RCCGrid
						container
						item		
					>
						<LovUsers 
							control={control}
							name="adb001Efa005Id2"
							label={translate("Responsável")}
							error={error.adb001Efa005Id2}
							defaultValue={audit.adb001Efa005Id2 ? defaultValue(audit.adb001Efa005Id2, audit.adb001Efa005Nome2) : {
								value: user.efa005Id.toString(),
								label: user.efa005Nome
							}}
							disabled={isDisabled}
							required
						/> 
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default FormSimplifiedFields;
